"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_exports = {};
__export(index_exports, {
  closeLiveQueries: () => import_init.closeLiveQueries,
  createCollaboratorsQuery: () => createCollaboratorsQuery,
  createLabelsQuery: () => createLabelsQuery,
  createMessagesQuery: () => createMessagesQuery,
  createNotificationContextsQuery: () => createNotificationContextsQuery,
  createNotificationsQuery: () => createNotificationsQuery,
  initLiveQueries: () => import_init.initLiveQueries,
  refreshLiveQueries: () => import_init.refreshLiveQueries
});
module.exports = __toCommonJS(index_exports);
var import_query = require("./query");
var import_init = require("./init");
function createMessagesQuery(dontDestroy) {
  return new import_query.MessagesQuery(dontDestroy);
}
__name(createMessagesQuery, "createMessagesQuery");
function createNotificationsQuery(dontDestroy) {
  return new import_query.NotificationsQuery(dontDestroy);
}
__name(createNotificationsQuery, "createNotificationsQuery");
function createNotificationContextsQuery(dontDestroy) {
  return new import_query.NotificationContextsQuery(dontDestroy);
}
__name(createNotificationContextsQuery, "createNotificationContextsQuery");
function createLabelsQuery(dontDestroy) {
  return new import_query.LabelsQuery(dontDestroy);
}
__name(createLabelsQuery, "createLabelsQuery");
function createCollaboratorsQuery(dontDestroy) {
  return new import_query.CollaboratorsQuery(dontDestroy);
}
__name(createCollaboratorsQuery, "createCollaboratorsQuery");
//# sourceMappingURL=index.js.map
